import {
    DESCRIPTOR_HEADER,
    PACKET_BYTES,
    RESERVED_BYTE,
    FADE_DB_PER_STEP,
} from "./constants.js";
import { crc16 } from "./crc.js";

/**
 * Builds a 16-byte AD_descriptor with the WHP 198 CRC in the last 2 bytes.
 *
 * @param {{ fade?: number, pan?: number }} values - AD_fade_byte and
 *   AD_pan_byte (0-255)
 * @returns {Uint8Array}
 */
export function buildAdDescriptor({ fade = 0, pan = 0 } = {}) {
    const bytes = new Uint8Array(PACKET_BYTES).fill(RESERVED_BYTE);
    bytes.set(DESCRIPTOR_HEADER, 0);
    bytes[7] = fade & 0xff;
    bytes[8] = pan & 0xff;
    const crc = crc16(bytes.subarray(0, PACKET_BYTES - 2));
    bytes[14] = crc >> 8;
    bytes[15] = crc & 0xff;
    return bytes;
}

/**
 * Converts an attenuation in dB (e.g. -12) to an AD_fade_byte.
 *
 * @param {number} db
 * @returns {number}
 */
export function dbToFadeByte(db) {
    if (!Number.isFinite(db) || db >= 0) return 0;
    return Math.min(255, Math.max(0, Math.round(-db / FADE_DB_PER_STEP)));
}

/**
 * Converts a linear gain (e.g. 0.25) to an attenuation in dB.
 *
 * @param {number} gain
 * @returns {number}
 */
export function gainToDb(gain) {
    if (!(gain > 0)) return -Infinity;
    return 20 * Math.log10(gain);
}
